<button
  fd-button
  class="open-actions-button"
  [disabled]="disabled"
  [fdCompact]="true"
  fdType="transparent"
  title="Actions"
  [fdMenuTrigger]="menu"
  i18n-title="XTOL|Tooltip of the Action button@@tableActionButtonTooltip"
>
  <app-icon icon="ellipsis-vertical" size="lg"></app-icon>
</button>
<fd-menu
  #menu
  [fdCompact]="true"
  (isOpenChange)="setIsOpen($event)"
  [noArrow]="false"
  [scrollStrategy]="scrollStrategy"
  placement="bottom"
>  <fd-busy-indicator
    [block]="true"
    size="m"
    [loading]="busy"
    ariaLabel="loading"
  >
    <div [style.visibility]="busy ? 'hidden' : 'visible'" class="action-menu">
      <li
        fd-menu-item
        class="actions-edit-btn"
        [disabled]="isEditButtonEnabled"
      >
        <a
          [routerLink]=""
          id="edit-action"
          fd-menu-interactive
          (click)="editResource(resource)"
        >
          <span
            fd-menu-title
            i18n="
              XMIT|Edit button in Action
              Sheet@organizations.actions.edit@@organizationTableEditAction"
            >Edit</span
          >
        </a>
      </li>
      @if (showAnalyzeFailure) {
        <li fd-menu-item class="actions-analyze-failure-btn">
          <a
            [routerLink]=""
            id="analyze-failure-action"
            fd-menu-interactive
            (click)="actionPicked('analyzeFailure')"
          >
            <span fd-menu-title>Analyze Failure</span>
          </a>
        </li>
      }
      @if (showEditableWithYaml) {
        <li
          fd-menu-item
          class="actions-edit-btn"
          [disabled]="isEditWithYamlEnabled"
        >
          <a
            [routerLink]=""
            id="edit-yaml-action"
            fd-menu-interactive
            (click)="actionPicked('edit')"
          >
            <span
              fd-menu-title
              i18n="
                XMIT|Open details action button in Action
                Sheet@organizations.actions.details@@organizationTableDetailsAction"
              >Edit with YAML</span
            >
          </a>
        </li>
      }
      @if (isFull) {
        @if (isFclClosed) {
          <li fd-menu-item class="actions-edit-btn">
            <a
              [routerLink]=""
              id="open-action"
              fd-menu-interactive
              (click)="actionPicked('open')"
            >
              <span
                fd-menu-title
                i18n="
                  XMIT|Open details action button in Action
                  Sheet@organizations.actions.details@@organizationTableDetailsAction"
                >View Details</span
              >
            </a>
          </li>
        }
        @if (isFclClosed && Utils.isManagedService(resource)) {
          <li fd-menu-item class="actions-edit-btn">
            <a
              [routerLink]=""
              id="RTD-type-resources-action"
              fd-menu-interactive
              (click)="actionPicked('showRTDResources')"
            >
              <span
                fd-menu-title
                i18n="
                  XMIT|Open RTD resources action button in Action
                  Sheet@organizations.actions.esources@@organizationTableResourcesAction"
                >View RTD Type Resources</span
              >
            </a>
          </li>
        }
        @if (isFclClosed) {
          <li fd-menu-item class="actions-edit-btn">
            <a
              [routerLink]=""
              id="events-action"
              fd-menu-interactive
              (click)="actionPicked('events')"
            >
              <span
                fd-menu-title
                i18n="
                  XMIT|Open events action button in Action
                  Sheet@organizations.actions.events@@organizationTableEventsAction"
                >View Events</span
              >
            </a>
          </li>
        }
        @if (advancedSearchOpen) {
          <li fd-menu-item>
            <a [routerLink]="" fd-menu-interactive (click)="navigateToResource()">
              <span
                fd-menu-title
                i18n="
                  XMIT|Copy Path button in Action
                  Sheet@organizations.actions.copyPath@@organizationTableCopyPathAction"
                >Locate in Organization Explorer</span
              >
            </a>
          </li>
        }
      }
      <li fd-menu-item>
        <a [routerLink]="" fd-menu-interactive (click)="onCopyPath()">
          <span
            fd-menu-title
            i18n="
              XMIT|Copy Path button in Action
              Sheet@organizations.actions.copyPath@@organizationTableCopyPathAction"
            >Copy Path</span
          >
        </a>
      </li>
      @if (isMoveResourceButtonEnabled) {
        <li fd-menu-item>
          <a [routerLink]="" fd-menu-interactive (click)="actionPicked('move')">
            <span
              fd-menu-title
              i18n="
                XMIT|Move Resource button in Action
                Sheet@organizations.actions.moveResource@@organizationTableMoveResourceAction"
              >Move</span
            >
          </a>
        </li>
      }
      <li fd-menu-item>
        <a
          [routerLink]=""
          id="reconcile-action"
          class="actions-reconcile-btn"
          fd-menu-interactive
          (click)="actionPicked('reconcile')"
        >
          <span
            fd-menu-title
            i18n="
              XMIT|Reconcile button in Action
              Sheet@organizations.actions.delete@@organizationTableReconcileAction"
            >Reconcile</span
          >
        </a>
      </li>
      <li fd-menu-item [disabled]="!isDeleteButtonEnabled">
        <a
          [routerLink]=""
          id="delete-action"
          class="actions-delete-btn"
          fd-menu-interactive
          (click)="actionPicked('delete')"
        >
          <span
            fd-menu-title
            i18n="
              XMIT|Delete button in Action
              Sheet@organizations.actions.delete@@organizationTableDeleteAction"
            >Delete</span
          >
        </a>
      </li>
    </div>
  </fd-busy-indicator>
</fd-menu>
